import type { Query } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { getProductSellingPrices } from "./productsApi";
import dayjs, { ISO_DATE_FORMAT } from "../../dayjs";

export function productSellingPricesQueryKey(
  productId: string,
  params: { readonly dateFrom: string; readonly dateTo: string; readonly participantsNumber: number },
) {
  return ["products", productId, "prices", "selling", params];
}

export function isProductSellingPricesQuery(productId: string) {
  return ({ queryKey }: Query) =>
    Array.isArray(queryKey) &&
    queryKey.length === 5 &&
    queryKey[0] === "products" &&
    queryKey[1] === productId &&
    queryKey[2] === "prices" &&
    queryKey[3] === "selling" &&
    typeof queryKey[4] === "object";
}

export const useProductSellingPrices = (productId: string, date: string, participantsNumber: number) => {
  const params = {
    dateFrom: date,
    dateTo: dayjs(date, ISO_DATE_FORMAT).add(1, "day").format(ISO_DATE_FORMAT),
    participantsNumber,
  };
  const { data, isLoading, error } = useQuery({
    queryKey: productSellingPricesQueryKey(productId, params),
    queryFn: ({ signal }) => getProductSellingPrices(productId, params, signal),
  });
  return { prices: data ?? {}, isLoading, error };
};
